import useText from '@/hooks/useText';
import { ComputerDesktopIcon } from '@heroicons/react/24/outline';


const foundationCardIcons = {
  quality: <img src="/static/images/icons/iconsPink/011.svg" alt="Quality" className="w-14 h-14 mr-4" />,
  standardization: (
    <img src="/static/images/icons/iconsPink/051.svg" alt="Standardization" className="w-14 h-14 mr-4" />
  ),
  integration: (
    <img src="/static/images/icons/iconsPink/038.svg" alt="Integration" className="w-14 h-14 mr-4" />
  ),
  evidence: <img src="/static/images/icons/iconsPink/012.svg" alt="Evidence" className="w-14 h-14 mr-4" />,
};

export function useStats() {
  const years = useText('about_disgenet.hero.stats.years');
  const sources = useText('about_disgenet.hero.stats.sources');
  const citations = useText('about_disgenet.hero.stats.citations');

  return [
    { id: 1, title: years },
    { id: 2, title: sources },
    { id: 3, title: citations },
  ];
}

export function useSources() {
  const genomic = useText('about_disgenet.hero.diagram.genomic');
  const biobanks = useText('about_disgenet.hero.diagram.biobanks');
  const trials = useText('about_disgenet.hero.diagram.trials');
  const literature = useText('about_disgenet.hero.diagram.literature');

  return [
    { id: 1, title: genomic },
    { id: 2, title: biobanks },
    { id: 3, title: trials },
    { id: 4, title: literature },
  ];
}

export function useAccessTypes() {
  const explore = useText('about_disgenet.use_cases.explore_title');
  const explore_subtitle = useText('about_disgenet.use_cases.explore_subtitle');
  const api = useText('about_disgenet.use_cases.api_title');
  const api_subtitle = useText('about_disgenet.use_cases.api_subtitle');
  const integrate = useText('about_disgenet.use_cases.integrate_title');
  const integrate_subtitle = useText('about_disgenet.use_cases.integrate_subtitle');
  const discover_hint = useText('about_disgenet.use_cases.discover_hint');
  const programmatic_hint = useText('about_disgenet.use_cases.programmatic_hint');
  const power_ai_hint = useText('about_disgenet.use_cases.power_ai_hint');


  return [
    {
      id: 1,
      title: explore,
      description: explore_subtitle,
      hint: discover_hint,
      icon: <ComputerDesktopIcon className="w-8 h-8 text-pink" />,
    },
    {
      id: 2,
      title: api,
      description: api_subtitle,
      hint: programmatic_hint,
      icon: <img src="/static/images/eyesAida.svg" alt="AIDA" className="w-8 h-8" />,
    },
    {
      id: 3,
      title: integrate,
      description: integrate_subtitle,
      hint: power_ai_hint,
      icon: <img src="/static/images/icons/iconsPink/08_copy.svg" alt="pipeline" className="w-8 h-8" />,
    },
  ];
}

export function useFoundationCards() {
  const qualityTitle = useText('about_disgenet.foundation.cards.quality.title');
  const qualityPoint1 = useText('about_disgenet.foundation.cards.quality.point1');
  const qualityPoint2 = useText('about_disgenet.foundation.cards.quality.point2');
  const qualityBadge = useText('about_disgenet.foundation.cards.quality.badge');

  const standardizationTitle = useText('about_disgenet.foundation.cards.standardization.title');
  const standardizationPoint1 = useText('about_disgenet.foundation.cards.standardization.point1');
  const standardizationPoint2 = useText('about_disgenet.foundation.cards.standardization.point2');
  const standardizationBadge = useText('about_disgenet.foundation.cards.standardization.badge');

  const integrationTitle = useText('about_disgenet.foundation.cards.integration.title');
  const integrationPoint1 = useText('about_disgenet.foundation.cards.integration.point1');
  const integrationPoint2 = useText('about_disgenet.foundation.cards.integration.point2');
  const integrationBadge = useText('about_disgenet.foundation.cards.integration.badge');

  const evidenceTitle = useText('about_disgenet.foundation.cards.evidence.title');
  const evidencePoint1 = useText('about_disgenet.foundation.cards.evidence.point1');
  const evidencePoint2 = useText('about_disgenet.foundation.cards.evidence.point2');
  const evidenceBadge = useText('about_disgenet.foundation.cards.evidence.badge');

  return [
    {
      title: qualityTitle,
      points: [qualityPoint1, qualityPoint2],
      badgeText: qualityBadge,
      icon: foundationCardIcons.quality,
    },
    {
      title: standardizationTitle,
      points: [standardizationPoint1, standardizationPoint2],
      badgeText: standardizationBadge,
      icon: foundationCardIcons.standardization,
    },
    {
      title: integrationTitle,
      points: [integrationPoint1, integrationPoint2],
      badgeText: integrationBadge,
      icon: foundationCardIcons.integration,
    },
    {
      title: evidenceTitle,
      points: [evidencePoint1, evidencePoint2],
      badgeText: evidenceBadge,
      icon: foundationCardIcons.evidence,
    },
  ];
}
